import { createAction, createAsyncAction } from 'redux-promise-middleware-actions';
import dayjs from 'dayjs';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { globalPageSize, months } from '../utils/constants';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_EXPENSES: 'GET_PARTICULAR_EXPENSES',
    GET_NEXT_EXPENSES: 'GET_NEXT_EXPENSES',
    DELETE_CLAIM: 'DELETE_CLAIM'
  }),
  CHANGE_EXPENSES_STATUS: 'CHANGE_EXPENSES_STATUS'
};

let abortController;

const handleAbort = () => {
  if (abortController) {
    abortController.abort();
  }

  abortController = new AbortController();
};

const commonGetExpensesRequest = (
  id,
  pageNumber,
  pageSize,
  day,
  month,
  year,
  status,
  claim,
  contractor,
  t,
  isApprover,
  filtersOptions
) => {
  const getMonthIndex = (mon) => {
    let index;
    months(t).forEach((element, i) => {
      if (element === mon) index = i + 1;
    });
    return index;
  };

  let basicUrl = `v1/${isApprover ? 'get-expenses-by-approverId' : 'expense/dashboard'}?userId=${localStorage.getItem(
    'UserId'
  )}&PageNumber=${pageNumber || 1}
    &PageSize=${pageSize || globalPageSize}`;
  if (status && status !== t('common.general.all')) basicUrl += `&Status=${status}`;
  if (claim && claim !== t('common.general.all')) basicUrl += `&ClaimName=${claim}`;
  if (month && month !== t('common.general.all')) basicUrl += `&Month=${getMonthIndex(month)}`;
  if (year && year !== t('common.general.all')) basicUrl += `&Year=${year}`;
  if (month && !year) basicUrl += `&Year=${filtersOptions.Years.at(-1).Year}`;
  if (day && day !== t('common.general.all')) basicUrl += `&Date=${dayjs(day).format('YYYY-MM-DD')}`;
  if (contractor?.FirstName && contractor?.LastName && contractor !== t('common.general.all'))
    basicUrl += `&FirstName=${contractor.FirstName}&LastName=${contractor.LastName}`;

  handleAbort();

  return tneAxiosClient.get(basicUrl, { signal: abortController.signal }).then((res) => res?.data);
};

export const getExpenses = createAsyncAction(types.GET_EXPENSES, commonGetExpensesRequest);

export const getNextExpenses = createAsyncAction(types.GET_NEXT_EXPENSES, commonGetExpensesRequest);

export const changeExpensesStatus = createAction(types.CHANGE_EXPENSES_STATUS, (status) => status);

export const deleteClaim = createAsyncAction(types.DELETE_CLAIM, (id) => {
  return tneAxiosClient.delete(`v1/expense?expenseId=${id}`).then(() => id);
});
